import { SavingTicket } from '../../api-clients/api-types'

export type Period = {
  isPeriodicTicket: boolean
  startDate: Date
  endDate: Date
  cancelDate?: Date
}

export const isPeriodTicket = (savingTicket: SavingTicket) =>
  (savingTicket.lastTravelDate.getTime() - savingTicket.travelDate.getTime()) / (1000 * 3600 * 24) > 1

export const calculatePeriod = (savingTicket: SavingTicket, month: number, year: number): Period => {
  const isPeriodicTicket = isPeriodTicket(savingTicket)
  const startOfMonth = new Date(year, month - 1, 1)
  const endOfMonth = new Date(year, month, 0)
  const travelDateAfterMonthStart = savingTicket?.travelDate > startOfMonth
  const lastTravelDateBeforeMonthEnd = savingTicket?.lastTravelDate < endOfMonth

  const startDate = travelDateAfterMonthStart ? savingTicket?.travelDate : startOfMonth
  const endDate = lastTravelDateBeforeMonthEnd ? savingTicket?.lastTravelDate : endOfMonth

  const cancelDate = savingTicket?.effectiveCancellationDate

  return {
    isPeriodicTicket,
    startDate,
    endDate,
    cancelDate,
  }
}

export const roundString = (saving?: string): number => {
  return round(parseFloat(saving || '0.00'))
}

export const round = (saving: number): number => {
  return Math.round(saving * 100) / 100
}

export const betweenDates = (month: number, year: number, firstDate: Date, lastDate: Date) => {
  const startOfMonth = new Date(year, month - 1, 1)
  const endOfMonth = new Date(year, month, 0)

  if (month === 0) {
    return firstDate.getFullYear() === year
  }

  return firstDate <= endOfMonth && lastDate >= startOfMonth
}

export const savingPrintFormat = (saving?: string) => {
  const decimals = saving?.split('.')
  if (decimals === undefined) {
    return saving
  }
  if (decimals[1] === undefined) {
    return `${saving},00`
  }
  if (decimals[1].length === 1) {
    return `${decimals[0]},${decimals[1]}0`
  }

  return `${decimals[0]},${decimals[1]}`
}

export const getNumberOfSavingDaysInMonth = (periodCalculations: Period) => {
  return periodCalculations.endDate.getDate() - periodCalculations.startDate.getDate() + 1
}

export const getNumberOfRefundedDaysInMonth = (periodCalculations: Period) => {
  // Not cancelled
  if (!periodCalculations.cancelDate) {
    return 0
  }

  if (!periodCalculations.isPeriodicTicket) {
    return 1
  }

  // refund after end
  if (periodCalculations.cancelDate >= periodCalculations.endDate) {
    return 0
  }

  // refund before month start
  if (periodCalculations.cancelDate < periodCalculations.startDate) {
    return periodCalculations.endDate.getDate() - periodCalculations.startDate.getDate() + 1
  }

  // refund within month
  return periodCalculations.endDate.getDate() - periodCalculations.cancelDate.getDate()
}
